import React from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import PropTypes from "prop-types";
import AdSenseModal from "./AdSenseModal";
import AdSense from "react-adsense";
import projectConfig from "@projectConfig";

const AdSenseWidget = ({ settings, role }) => {
   return (
      <Widget
         bgColor={settings.backgroundColourHex}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               <SettingsModal
                  widgetName={settings.name}
                  widgetId={settings.id}
                  icon="setting"
                  deleteIcon="true"
                  children={<AdSenseModal settings={settings} />}
               />
            )
         }
      >
         <AdSense.Google
            client={projectConfig.adSense?.clientId ?? "ca-"}
            slot={projectConfig.adSense?.slotId}
         />
      </Widget>
   );
};

AdSenseWidget.propTypes = {
   settings: PropTypes.object.isRequired,
   role: PropTypes.string.isRequired
};

export default AdSenseWidget;
